const initialState = () => ({
  all: [],
  duration: 3000
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async create({ dispatch, commit }, payload) {
      const toast_id = +new Date()
      commit('add', {
        ...payload,
        toast_id
      })
      await dispatch('wait')
      commit('remove', toast_id)
    },
    async wait({ state }) {
      return new Promise(r => setTimeout(r, state.duration))
    }
  },
  mutations: {
    add(state, payload) {
      state.all.push(payload)
    },
    remove(state, toastId) {
      const foundIndex = state.all.findIndex(t => t.toast_id === toastId)
      if (foundIndex !== -1) return state.all.splice(foundIndex)
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
